import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { hoyEcuador } from '../../utils/fechas';
import printerService from '../../services/printerService';
import billingService from '../../services/billingService';
import PagoMixto, { lineasMixtoIniciales, resumirPagoMixto } from '../../comun/PagoMixto';
import AvisoSaldoFavor, { saldoDelCliente, saldoAlcanza, EtiquetaSaldo } from '../../comun/AvisoSaldoFavor';
import SelectorVendedor, { leerUltimoVendedor } from '../../comun/SelectorVendedor';

const CafeGrano = () => {
    // Parámetros de Café
    const PRICE_PER_GRAM = 0.02; // $20.00 por 1000g ($0.02 / gramo)

    // Estados de la calculadora de venta
    const [weightGrams, setWeightGrams] = useState(500);
    const [packageCount, setPackageCount] = useState(1);
    const [grindType, setGrindType] = useState('grano'); // 'grano', 'fino', 'medio', 'grueso'
    const [roastType, setRoastType] = useState('especialidad'); // 'especialidad', 'medio', 'oscuro'
    const [customerName, setCustomerName] = useState('CONSUMIDOR FINAL');
    const [customerDni, setCustomerDni] = useState('9999999999999');
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    // Pago Mixto: varias formas de pago en la misma venta (efectivo, transferencia, tarjeta y/o fiado)
    const [mixLines, setMixLines] = useState(lineasMixtoIniciales());
    const [exchangeRate] = useState(parseFloat(localStorage.getItem('usdExchangeRate')) || 4000);
    // Trabajador que realiza la venta
    const [sellerId, setSellerId] = useState(leerUltimoVendedor());
    const [saleDate, setSaleDate] = useState(() => hoyEcuador());
    const [notes, setNotes] = useState('');

    // Selector de Cliente
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerSearch, setCustomerSearch] = useState('');
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [newCustomer, setNewCustomer] = useState({
        email: '',
        password: 'Password123!',
        password_confirmation: 'Password123!',
        first_name: '',
        last_name: '',
        phone: '',
        address: '',
        city: '',
        cedula: ''
    });

    const searchCustomers = async (query) => {
        setCustomerSearch(query);
        if (query.length < 3) {
            setCustomers([]);
            return;
        }
        try {
            const res = await api.post('/api/customers/admin/search/', { query }, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            setCustomers(res.data?.data?.customers || []);
        } catch (err) {
            console.error('Error buscando clientes:', err);
        }
    };

    const handleSelectCustomer = (c) => {
        setSelectedCustomer(c);
        const fullName = `${c.first_name} ${c.last_name}`.trim();
        setCustomerSearch(fullName);
        setCustomerName(fullName);
        setCustomerDni(c.cedula || c.dni || '9999999999999');
        setCustomers([]);
    };

    const handleClearCustomer = () => {
        setSelectedCustomer(null);
        setCustomerSearch('');
        setCustomerName('CONSUMIDOR FINAL');
        setCustomerDni('9999999999999');
        setCustomers([]);
    };

    const handleCreateCustomer = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/api/customers/register/', {
                ...newCustomer,
                cedula: newCustomer.cedula || null
            }, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            const c = res.data?.data?.customer;
            alert('Cliente creado exitosamente');
            setShowCustomerModal(false);
            handleSelectCustomer(c);
            setNewCustomer({
                email: '',
                password: 'Password123!',
                password_confirmation: 'Password123!',
                first_name: '',
                last_name: '',
                phone: '',
                address: '',
                city: '',
                cedula: ''
            });
        } catch (err) {
            const errorData = err.response?.data;
            let msg = 'Error al crear cliente';
            if (errorData?.errors) {
                msg += ':\n' + Object.entries(errorData.errors).map(([k, v]) => `- ${k}: ${v}`).join('\n');
            } else if (errorData?.message) {
                msg += ': ' + errorData.message;
            } else {
                msg += ': ' + err.message;
            }
            alert(msg);
        }
    };

    // Datos y estadísticas
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [selectedDate, setSelectedDate] = useState(hoyEcuador());
    const [recentOrders, setRecentOrders] = useState([]);
    const [stats, setStats] = useState({
        total_grams: 0,
        total_kg: 0,
        total_sales_usd: 0,
        total_orders: 0
    });

    // Preview Ticket Modal
    const [previewOrder, setPreviewOrder] = useState(null);
    const [voucherConfig, setVoucherConfig] = useState({
        business_name: "SOPHIA'S COFFEE",
        ruc: '0401788617001',
        establishment_address: 'Tulcán, Carchi - Ecuador'
    });

    // Preset rápido de gramos
    const presets = [
        { label: '200g (Funda Pequeña)', grams: 200, price: 4.00, tag: '$4.00' },
        { label: '500g (1/2 Kilo)', grams: 500, price: 10.00, tag: '$10.00' },
        { label: '1000g (1 Kilo)', grams: 1000, price: 20.00, tag: '$20.00' },
        { label: '2500g (2.5 Kg Especial)', grams: 2500, price: 50.00, tag: '$50.00' }
    ];

    const grindOptions = [
        { id: 'grano', title: 'En Grano Entero', subtitle: 'Para moler al momento en casa', icon: 'bi-gem' },
        { id: 'fino', title: 'Molienda Fina', subtitle: 'Ideal para Espresso, Cafetera Italiana / Moka', icon: 'bi-cup-hot-fill' },
        { id: 'medio', title: 'Molienda Media', subtitle: 'Ideal para V60, Chemex, Filtro / Goteo', icon: 'bi-funnel-fill' },
        { id: 'grueso', title: 'Molienda Gruesa', subtitle: 'Ideal para Prensa Francesa, Cold Brew', icon: 'bi-cup-straw' }
    ];

    useEffect(() => {
        loadData();
        loadVoucherConfig();
    }, [selectedDate]);

    const loadVoucherConfig = async () => {
        try {
            const data = await billingService.getConfig();
            if (data) {
                setVoucherConfig(data);
            }
        } catch (e) {
            console.error('Error cargando voucher config:', e);
        }
    };

    const loadData = async () => {
        setLoading(true);
        try {
            // Cargar Órdenes de Café en Grano
            const ordersRes = await api.get('/api/orders/orders/', {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                params: {
                    business_type: 'cafe_grano',
                    date_from: `${selectedDate}T00:00:00`,
                    date_to: `${selectedDate}T23:59:59`
                }
            });

            const ordersList = Array.isArray(ordersRes.data) ? ordersRes.data : (ordersRes.data.results || []);
            setRecentOrders(ordersList);

            // Calcular estadísticas
            let totalGrams = 0;
            let totalSales = 0;
            ordersList.forEach(order => {
                const g = parseFloat(order.coffee_grams || 0) || (order.items && order.items.reduce((acc, it) => acc + (it.quantity * 500), 0)) || 0;
                totalGrams += g;
                totalSales += parseFloat(order.total || order.total_amount || 0);
            });

            setStats({
                total_grams: totalGrams,
                total_kg: (totalGrams / 1000).toFixed(2),
                total_sales_usd: totalSales.toFixed(2),
                total_orders: ordersList.length
            });
        } catch (err) {
            console.error('Error cargando órdenes de café en grano:', err);
        } finally {
            setLoading(false);
        }
    };

    // Cálculos en vivo
    const unitPrice = (weightGrams * PRICE_PER_GRAM);
    const totalPrice = (unitPrice * packageCount);

    const getGrindLabel = (id) => {
        const found = grindOptions.find(g => g.id === id);
        return found ? found.title : id;
    };

    const handleRegisterCoffeeSale = async (e) => {
        e.preventDefault();
        const grams = parseInt(weightGrams, 10);
        const count = parseInt(packageCount, 10);

        if (isNaN(grams) || grams <= 0) {
            alert('Por favor especifica un peso válido en gramos.');
            return;
        }
        if (isNaN(count) || count <= 0) {
            alert('Por favor especifica una cantidad válida de paquetes.');
            return;
        }

        setSubmitting(true);
        try {
            // Obtener producto de café en grano del catálogo
            let productId = null;
            try {
                const menuRes = await api.get('/api/menu/products/', {
                    baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                    params: { search: 'Café en Grano' }
                });
                const prods = Array.isArray(menuRes.data) ? menuRes.data : (menuRes.data.results || []);
                // 1. Si coincide con un preset exacto (ej. 200g, 500g, 1000g, 2500g)
                const exactMatch = prods.find(p => p.name.includes(`${grams}g`));
                // 2. Si es gramaje personalizado (ej. 1100g, 350g), usar producto base "al peso"
                const alPesoMatch = prods.find(p => p.name.toLowerCase().includes('al peso') || p.slug === 'cafe-en-grano-molido-al-peso');
                // 3. Fallback a cualquier producto de café o grano del catálogo
                const genericMatch = prods.find(p => p.name.toLowerCase().includes('grano') || p.name.toLowerCase().includes('café'));
                const cafeProd = exactMatch || alPesoMatch || genericMatch || prods[0];
                if (cafeProd) productId = cafeProd.id;
            } catch (err) {
                console.warn('Error buscando producto de café en menú:', err);
            }

            if (!productId) {
                // Si la búsqueda falló, obtener lista general de productos
                const allProdsRes = await api.get('/api/menu/products/', {
                    baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
                });
                const allProds = Array.isArray(allProdsRes.data) ? allProdsRes.data : (allProdsRes.data.results || []);
                const found = allProds.find(p => p.name.toLowerCase().includes('café') || p.name.toLowerCase().includes('grano')) || allProds[0];
                if (found) productId = found.id;
            }

            if (!productId) {
                throw new Error('No se encontró el producto Café en Grano en el menú.');
            }

            const totalGramsSold = grams * count;
            const finalTotal = totalPrice.toFixed(2);
            const isMixed = paymentMethod === 'dividido';
            const isFiado = paymentMethod === 'fiado' || paymentMethod === 'credito';
            const isSaldo = paymentMethod === 'saldo';
            const mix = resumirPagoMixto(mixLines, totalPrice, exchangeRate);

            if (isMixed && !mix.valid) {
                alert(`Los montos del pago mixto ($${mix.entered.toFixed(2)} USD) no cubren el total ($${finalTotal} USD). Por favor, verifica los montos.`);
                setSubmitting(false);
                return;
            }

            // Lo fiado se cobra al cliente o, si no se registró cliente, al vendedor
            if ((isFiado || (isMixed && mix.hasCredit)) && !selectedCustomer && !sellerId) {
                alert('Para registrar una venta a Fiado, selecciona el vendedor (o un cliente) para saber a quién cobrar.');
                setSubmitting(false);
                return;
            }

            // El saldo a favor se descuenta del cliente seleccionado y debe alcanzar
            const saldo = saldoDelCliente(selectedCustomer);
            const saldoAUsar = isSaldo ? totalPrice : (isMixed ? mix.balance_amount : 0);
            if (saldoAUsar > 0 && saldo === null) {
                alert('Para pagar con saldo a favor, selecciona el cliente.');
                setSubmitting(false);
                return;
            }
            if (saldoAUsar > 0 && saldoAUsar > saldo + 0.009) {
                alert(`El cliente solo tiene $${saldo.toFixed(2)} de saldo a favor (se necesitan $${saldoAUsar.toFixed(2)}).` +
                    (isSaldo ? '\nUsa "Mixto" para pagar el resto con otra forma de pago.' : ''));
                setSubmitting(false);
                return;
            }

            const finalCustomerName = selectedCustomer ? `${selectedCustomer.first_name} ${selectedCustomer.last_name}`.trim() : customerName;
            const finalCustomerDni = selectedCustomer ? (selectedCustomer.cedula || customerDni) : customerDni;
            const description = `${count}x Funda(s) Café Sophia's (${grams}g c/u - ${getGrindLabel(grindType)})`;

            const payload = {
                order_type: 'takeout',
                order_date: saleDate,
                payment_method: isFiado ? 'fiado' : paymentMethod,
                status: 'completed',
                cash_amount: isMixed ? mix.cash_amount : (paymentMethod === 'efectivo' ? finalTotal : 0),
                transfer_amount: isMixed ? mix.transfer_amount : (paymentMethod === 'transferencia' ? finalTotal : 0),
                card_amount: isMixed ? mix.card_amount : (paymentMethod === 'tarjeta' ? finalTotal : 0),
                credit_amount: isMixed ? mix.credit_amount : 0,
                balance_amount: isMixed ? mix.balance_amount : 0,
                business_type: 'cafe_grano',
                coffee_grams: totalGramsSold,
                grind_type: grindType,
                customer_id: selectedCustomer ? selectedCustomer.id : null,
                seller_id: sellerId || null,
                notes: [`${description}. Cliente: ${finalCustomerName} (CI: ${finalCustomerDni})`, notes, isMixed ? mix.note : '']
                    .filter(Boolean).join('. '),
                items: [
                    {
                        product_id: productId,
                        quantity: count,
                        unit_price: unitPrice.toFixed(2),
                        notes: `Molienda: ${getGrindLabel(grindType)} (${grams}g c/u)`
                    }
                ]
            };

            const res = await api.post('/api/orders/orders/', payload, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });

            alert(`Venta de café registrada: ${count}x ${grams}g (${totalGramsSold}g total) por $${finalTotal} USD` +
                (saldoAUsar > 0 ? `\nDescontado del saldo a favor de ${finalCustomerName}: $${saldoAUsar.toFixed(2)} (le quedan $${(saldo - saldoAUsar).toFixed(2)})` : '') +
                (isMixed && mix.hasCredit ? `\nFiado a ${finalCustomerName}: $${mix.credit_amount.toFixed(2)}` : ''));

            const createdOrder = res.data;

            setPreviewOrder({
                ...createdOrder,
                ...(isMixed ? { payment_method: 'mixto' } : {}),
                customer_name: finalCustomerName,
                customer_dni: finalCustomerDni,
                total: finalTotal,
                total_grams: totalGramsSold,
                grind_label: getGrindLabel(grindType),
                weight_per_pack: grams,
                pack_count: count
            });

            // Limpiar o resetear notas y cliente
            setNotes('');
            setMixLines(lineasMixtoIniciales());
            handleClearCustomer();
            loadData();
        } catch (error) {
            console.error('Error al registrar venta de café:', error);
            const errDetail = error.response?.data?.detail || 
                (typeof error.response?.data === 'object' ? JSON.stringify(error.response?.data) : error.response?.data) || 
                error.message;
            alert('Error al registrar venta de café: ' + errDetail);
        } finally {
            setSubmitting(false);
        }
    };

    const handlePrintTicket = async (order) => {
        try {
            const ticketData = {
                type: 'cafe_grano_ticket',
                order_number: order.order_sequence || order.id,
                date: order.created_at || new Date().toISOString(),
                customer: order.customer_name || 'CONSUMIDOR FINAL',
                dni: order.customer_dni || '9999999999999',
                grind_type: getGrindLabel(order.grind_type || grindType),
                total_grams: order.coffee_grams || (weightGrams * packageCount),
                pack_count: packageCount,
                price_per_gram: PRICE_PER_GRAM,
                total_usd: order.total_amount || totalPrice,
                payment_method: order.payment_method || paymentMethod,
                notes: order.notes,
                business: voucherConfig
            };

            await printerService.printVoucher(ticketData);
        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            window.print();
        }
    };

    return (
        <div style={{ padding: '1rem', maxWidth: '1400px', margin: '0 auto', color: 'var(--text-color)' }}>
            {/* Header del Módulo */}
            <div className="page-header-banner">
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem', flexWrap: 'wrap' }}>
                        <i className="bi bi-scale" style={{ fontSize: '1.75rem' }}></i>
                        <h1 style={{ margin: 0, fontSize: '1.65rem', fontWeight: 'bold', letterSpacing: '-0.5px' }}>
                            Café en Grano y Molido por Peso
                        </h1>
                    </div>
                    <p style={{ margin: 0, opacity: 0.9, fontSize: '0.9rem', maxWidth: '650px' }}>
                        Venta directa al peso ($0.02 USD por gramo / $20.00 por Kg). Selecciona el peso, tipo de molienda y emite el ticket al instante.
                    </p>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '0.6rem 1.2rem', borderRadius: '10px', textAlign: 'right' }}>
                        <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: 0.85, display: 'block' }}>
                            Tarifa Oficial
                        </span>
                        <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>$0.02 / gramo</span>
                    </div>
                </div>
            </div>

            {/* Tarjetas de Métricas de Café */}
            <div className="kpi-grid-responsive">
                <div style={{
                    background: 'var(--surface-color)',
                    padding: '1.25rem',
                    borderRadius: '14px',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                }}>
                    <div style={{
                        width: '52px',
                        height: '52px',
                        borderRadius: '12px',
                        background: '#FAF6F2',
                        color: 'var(--primary-color)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                        border: '1px solid #E6D7CD'
                    }}>
                        <i className="bi bi-cup-hot-fill"></i>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: '600', textTransform: 'uppercase' }}>
                            Café Vendido Hoy
                        </div>
                        <div style={{ fontSize: '1.6rem', fontWeight: '800', color: 'var(--primary-color)' }}>
                            {stats.total_kg} <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>Kg</span>
                        </div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                            ({stats.total_grams.toLocaleString()} gramos)
                        </div>
                    </div>
                </div>

                <div style={{
                    background: 'var(--surface-color)',
                    padding: '1.25rem',
                    borderRadius: '14px',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                }}>
                    <div style={{
                        width: '52px',
                        height: '52px',
                        borderRadius: '12px',
                        background: '#e6f4ea',
                        color: '#137333',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                    }}>
                        <i className="bi bi-cash-stack"></i>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: '600', textTransform: 'uppercase' }}>
                            Total Facturado Café
                        </div>
                        <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#137333' }}>
                            ${stats.total_sales_usd}
                        </div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                            Ingreso del día en café
                        </div>
                    </div>
                </div>

                <div style={{
                    background: 'var(--surface-color)',
                    padding: '1.25rem',
                    borderRadius: '14px',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                }}>
                    <div style={{
                        width: '52px',
                        height: '52px',
                        borderRadius: '12px',
                        background: '#e0f2fe',
                        color: '#0284c7',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                    }}>
                        <i className="bi bi-box-seam"></i>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: '600', textTransform: 'uppercase' }}>
                            Transacciones
                        </div>
                        <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#0284c7' }}>
                            {stats.total_orders}
                        </div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                            Ventas despachadas
                        </div>
                    </div>
                </div>

                <div style={{
                    background: 'var(--surface-color)',
                    padding: '1.25rem',
                    borderRadius: '14px',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                }}>
                    <div style={{
                        width: '52px',
                        height: '52px',
                        borderRadius: '12px',
                        background: '#fef3c7',
                        color: '#b45309',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                    }}>
                        <i className="bi bi-calendar-date"></i>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: '600', textTransform: 'uppercase' }}>
                            Fecha de Consulta
                        </div>
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            style={{
                                border: '1px solid var(--border-color)',
                                borderRadius: '6px',
                                padding: '0.3rem 0.5rem',
                                fontSize: '0.9rem',
                                fontWeight: 'bold',
                                color: 'var(--primary-color)',
                                outline: 'none'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Layout Principal: Calculadora y Ventas */}
            <div className="two-column-responsive-grid">
                {/* Panel Izquierdo: Calculadora y Formulario de Venta */}
                <div style={{
                    background: 'var(--surface-color)',
                    borderRadius: '16px',
                    padding: '2rem',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 4px 16px rgba(74, 31, 12, 0.05)'
                }}>
                    <h2 style={{ fontSize: '1.35rem', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <i className="bi bi-calculator"></i> Calculadora & Registro de Venta
                    </h2>

                    <form onSubmit={handleRegisterCoffeeSale}>
                        {/* Selección Rápida de Gramaje */}
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-color)' }}>
                                1. Selecciona o Ingresa los Gramos:
                            </label>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', marginBottom: '0.75rem' }}>
                                {presets.map((p) => {
                                    const isSelected = weightGrams === p.grams;
                                    return (
                                        <button
                                            key={p.grams}
                                            type="button"
                                            onClick={() => setWeightGrams(p.grams)}
                                            style={{
                                                padding: '0.85rem 1rem',
                                                borderRadius: '10px',
                                                border: isSelected ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
                                                background: isSelected ? 'var(--secondary-color)' : '#FFFFFF',
                                                color: isSelected ? 'var(--primary-color)' : 'var(--text-color)',
                                                fontWeight: isSelected ? '700' : '500',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                transition: 'all 0.2s ease',
                                                boxShadow: isSelected ? '0 4px 12px rgba(74, 31, 12, 0.1)' : 'none'
                                            }}
                                        >
                                            <span>{p.label}</span>
                                            <span style={{
                                                background: isSelected ? 'var(--primary-color)' : '#e2e8f0',
                                                color: isSelected ? '#FFFFFF' : '#475569',
                                                padding: '0.2rem 0.5rem',
                                                borderRadius: '6px',
                                                fontSize: '0.8rem',
                                                fontWeight: 'bold'
                                            }}>
                                                {p.tag}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Input Personalizado de Gramos */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                <div style={{ flex: 1, position: 'relative' }}>
                                    <input
                                        type="number"
                                        min="1"
                                        step="1"
                                        value={weightGrams}
                                        onChange={(e) => setWeightGrams(Math.max(1, parseInt(e.target.value) || 0))}
                                        placeholder="Ingresar gramos personalizados..."
                                        style={{
                                            width: '100%',
                                            padding: '0.75rem 1rem',
                                            paddingRight: '4.5rem',
                                            borderRadius: '8px',
                                            border: '1px solid var(--border-color)',
                                            fontSize: '1rem',
                                            fontWeight: '600',
                                            outline: 'none'
                                        }}
                                        required
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        right: '1rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        fontWeight: '700',
                                        color: 'var(--text-secondary)'
                                    }}>
                                        gramos
                                    </span>
                                </div>

                                <div style={{ width: '130px', position: 'relative' }}>
                                    <input
                                        type="number"
                                        min="1"
                                        max="50"
                                        value={packageCount}
                                        onChange={(e) => setPackageCount(Math.max(1, parseInt(e.target.value) || 1))}
                                        style={{
                                            width: '100%',
                                            padding: '0.75rem 1rem',
                                            paddingRight: '3.5rem',
                                            borderRadius: '8px',
                                            border: '1px solid var(--border-color)',
                                            fontSize: '1rem',
                                            fontWeight: '600',
                                            outline: 'none'
                                        }}
                                    />
                                    <span style={{
                                        position: 'absolute',
                                        right: '0.75rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        fontSize: '0.8rem',
                                        fontWeight: '700',
                                        color: 'var(--text-secondary)'
                                    }}>
                                        fundas
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Tipo de Molienda */}
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '700', marginBottom: '0.5rem', color: 'var(--text-color)' }}>
                                2. Tipo de Molienda:
                            </label>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem' }}>
                                {grindOptions.map((g) => {
                                    const isSelected = grindType === g.id;
                                    return (
                                        <div
                                            key={g.id}
                                            onClick={() => setGrindType(g.id)}
                                            style={{
                                                padding: '0.85rem 1rem',
                                                borderRadius: '10px',
                                                border: isSelected ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
                                                background: isSelected ? 'var(--secondary-color)' : '#FFFFFF',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                gap: '0.75rem',
                                                alignItems: 'flex-start'
                                            }}
                                        >
                                            <i className={`bi ${g.icon}`} style={{ fontSize: '1.3rem', color: 'var(--primary-color)' }}></i>
                                            <div>
                                                <div style={{ fontWeight: '700', fontSize: '0.9rem', color: isSelected ? 'var(--primary-color)' : 'var(--text-color)' }}>
                                                    {g.title}
                                                </div>
                                                <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.15rem' }}>
                                                    {g.subtitle}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Fecha de la Venta */}
                        <div style={{ marginBottom: '1.25rem', background: '#f8fafc', padding: '10px 14px', borderRadius: '10px', border: '1px solid var(--border-color)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                <label style={{ fontSize: '0.8rem', fontWeight: '700', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <i className="bi bi-calendar-event" style={{ color: 'var(--primary-color)' }}></i> 3. Fecha de la Venta:
                                </label>
                                {saleDate !== hoyEcuador() ? (
                                    <span style={{ fontSize: '10px', background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '10px', fontWeight: 'bold' }}>
                                        Venta Retroactiva
                                    </span>
                                ) : (
                                    <span style={{ fontSize: '10px', background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: '10px', fontWeight: '600' }}>
                                        Hoy
                                    </span>
                                )}
                            </div>
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <input
                                    type="date"
                                    value={saleDate}
                                    onChange={(e) => setSaleDate(e.target.value)}
                                    style={{
                                        flex: 1,
                                        padding: '0.65rem 0.85rem',
                                        borderRadius: '8px',
                                        border: '1px solid #cbd5e1',
                                        fontSize: '0.9rem',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        backgroundColor: '#ffffff'
                                    }}
                                />
                                {saleDate !== hoyEcuador() && (
                                    <button
                                        type="button"
                                        onClick={() => setSaleDate(hoyEcuador())}
                                        style={{
                                            padding: '0 12px',
                                            borderRadius: '8px',
                                            border: '1px solid #cbd5e1',
                                            background: '#f1f5f9',
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            color: '#475569',
                                            cursor: 'pointer'
                                        }}
                                        title="Volver a la fecha de hoy"
                                    >
                                        Hoy
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Trabajador que vendió */}
                        <SelectorVendedor value={sellerId} onChange={setSellerId} />

                        {/* Selector de Cliente */}
                        <div style={{ marginBottom: '1.25rem' }}>
                            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '700', marginBottom: '0.4rem', color: 'var(--text-primary)' }}>
                                <i className="bi bi-person-fill" style={{ color: 'var(--primary-color)', marginRight: '4px' }}></i> Cliente:
                            </label>
                            {selectedCustomer ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', backgroundColor: '#f0fdf4', border: '1.5px solid #86efac', borderRadius: '8px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontSize: '13px', fontWeight: '700', color: '#15803d' }}>
                                            {selectedCustomer.first_name} {selectedCustomer.last_name}
                                        </span>
                                        <span style={{ fontSize: '11px', color: '#64748b' }}>
                                            {selectedCustomer.cedula ? `CI: ${selectedCustomer.cedula}` : ''} {selectedCustomer.phone ? `· Tel: ${selectedCustomer.phone}` : ''} {selectedCustomer.email ? `· ${selectedCustomer.email}` : ''}
                                        </span>
                                        <EtiquetaSaldo customer={selectedCustomer} style={{ marginTop: '4px', alignSelf: 'flex-start' }} />
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleClearCustomer}
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '18px', padding: '4px 8px' }}
                                        title="Quitar cliente (volver a Consumidor Final)"
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <div style={{ position: 'relative', flex: 1 }}>
                                        <input
                                            type="text"
                                            placeholder="Buscar cliente por nombre, cédula o teléfono..."
                                            value={customerSearch}
                                            onChange={(e) => searchCustomers(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '0.65rem 0.85rem',
                                                borderRadius: '8px',
                                                border: '1.5px solid var(--border-color)',
                                                fontSize: '0.9rem',
                                                boxSizing: 'border-box',
                                                outline: 'none'
                                            }}
                                        />
                                        {customers.length > 0 && (
                                            <div style={{
                                                position: 'absolute',
                                                zIndex: 30,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1.5px solid #d1d5db',
                                                borderRadius: '8px',
                                                boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                                                marginTop: '4px',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}>
                                                {customers.map(c => (
                                                    <div
                                                        key={c.id}
                                                        style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9' }}
                                                        onClick={() => handleSelectCustomer(c)}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                                        onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                                    >
                                                        <div style={{ fontWeight: '700', fontSize: '13px', color: 'var(--primary-color)' }}>
                                                            {c.first_name} {c.last_name}
                                                        </div>
                                                        <div style={{ fontSize: '11px', color: '#6b7280' }}>
                                                            {c.email} {c.cedula && `· CI: ${c.cedula}`} {c.phone && `· Tel: ${c.phone}`}
                                                        </div>
                                                        <EtiquetaSaldo customer={c} style={{ marginTop: '4px' }} />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setShowCustomerModal(true)}
                                        title="Registrar nuevo cliente"
                                        style={{
                                            width: '42px',
                                            height: '42px',
                                            backgroundColor: 'var(--primary-color)',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '1.4rem',
                                            fontWeight: '300',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            )}
                            {!selectedCustomer && !customerSearch && (
                                <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
                                    Por defecto: <strong>{customerName}</strong> (puedes buscar uno existente o pulsar <strong>+</strong> para crearlo)
                                </div>
                            )}
                        </div>

                        {/* Método de Pago */}
                        <div style={{ marginBottom: '1.25rem' }}>
                            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '700', marginBottom: '0.4rem', color: 'var(--text-primary)' }}>
                                <i className="bi bi-wallet2" style={{ color: 'var(--primary-color)', marginRight: '4px' }}></i> Método de Pago:
                            </label>
                            <select
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '0.65rem 0.85rem',
                                    borderRadius: '8px',
                                    border: '1.5px solid var(--border-color)',
                                    fontSize: '0.9rem',
                                    background: '#fff'
                                }}
                            >
                                <option value="efectivo">Efectivo</option>
                                <option value="tarjeta">Tarjeta Débito / Crédito</option>
                                <option value="transferencia">Transferencia / DeUna</option>
                                <option value="fiado">Fiado (Cuenta por Cobrar)</option>
                                <option value="saldo">Saldo a favor del cliente (abono)</option>
                                <option value="dividido">Mixto (varias formas de pago)</option>
                            </select>

                            {paymentMethod === 'saldo' && (
                                <div style={{ marginTop: '8px' }}>
                                    <AvisoSaldoFavor customer={selectedCustomer} total={totalPrice} />
                                </div>
                            )}

                            {/* Pago Mixto: varias formas de pago en la misma venta */}
                            {paymentMethod === 'dividido' && (
                                <div style={{ marginTop: '8px' }}>
                                    <PagoMixto
                                        lineas={mixLines}
                                        onChange={setMixLines}
                                        total={totalPrice}
                                        exchangeRate={exchangeRate}
                                        hasDebtor={!!selectedCustomer || !!sellerId}
                                        saldoDisponible={saldoDelCliente(selectedCustomer)}
                                    />
                                </div>
                            )}

                            {/* Banner Fiado en Café en Grano */}
                            {paymentMethod === 'fiado' && (
                                <div style={{
                                    marginTop: '8px',
                                    padding: '10px 12px',
                                    backgroundColor: (selectedCustomer || sellerId) ? '#f0fdf4' : '#fef2f2',
                                    borderRadius: '8px',
                                    border: `1px solid ${(selectedCustomer || sellerId) ? '#bbf7d0' : '#fecaca'}`,
                                    color: (selectedCustomer || sellerId) ? '#166534' : '#991b1b',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <i className={`bi ${(selectedCustomer || sellerId) ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'}`} style={{ fontSize: '16px' }}></i>
                                    <span>
                                        {selectedCustomer ? (
                                            <>Venta a <strong>Fiado (Cuenta por Cobrar)</strong> asignada a <strong>{selectedCustomer.first_name} {selectedCustomer.last_name}</strong>.</>
                                        ) : sellerId ? (
                                            <>Venta a <strong>Fiado (Cuenta por Cobrar)</strong> a cargo del <strong>vendedor</strong>. Se cobra desde Trabajadores.</>
                                        ) : (
                                            <>Selecciona el <strong>vendedor</strong> (o un cliente) para saber a quién cobrar este fiado.</>
                                        )}
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* Resumen Total y Botón de Venta */}
                        <div style={{
                            background: '#FAF6F2',
                            borderRadius: '12px',
                            padding: '1.25rem',
                            border: '1px solid #E6D7CD',
                            marginBottom: '1.5rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', fontWeight: '600' }}>
                                    TOTAL A PAGAR ({weightGrams * packageCount}g de Café)
                                </div>
                                <div style={{ fontSize: '0.85rem', color: 'var(--primary-color)', fontWeight: '500' }}>
                                    {packageCount} funda(s) × ${unitPrice.toFixed(2)} USD
                                </div>
                            </div>
                            <div style={{ fontSize: '2.1rem', fontWeight: '900', color: 'var(--primary-color)' }}>
                                ${totalPrice.toFixed(2)} <span style={{ fontSize: '1rem', fontWeight: '600' }}>USD</span>
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={submitting || (paymentMethod === 'saldo' && !saldoAlcanza(selectedCustomer, totalPrice))}
                            style={{
                                width: '100%',
                                padding: '1rem',
                                background: (paymentMethod === 'saldo' && !saldoAlcanza(selectedCustomer, totalPrice)) ? '#ef4444' : 'var(--primary-color)',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '12px',
                                fontSize: '1.1rem',
                                fontWeight: '700',
                                cursor: submitting ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.75rem',
                                boxShadow: '0 4px 14px rgba(74, 31, 12, 0.25)',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {submitting ? (
                                <span>Procesando venta...</span>
                            ) : (
                                <>
                                    <i className="bi bi-check-circle-fill"></i>
                                    Registrar Venta e Imprimir Ticket (${totalPrice.toFixed(2)})
                                </>
                            )}
                        </button>
                    </form>
                </div>

                {/* Panel Derecho: Historial de Ventas de Café */}
                <div style={{
                    background: 'var(--surface-color)',
                    borderRadius: '16px',
                    padding: '2rem',
                    border: '1px solid var(--border-color)',
                    boxShadow: '0 4px 16px rgba(74, 31, 12, 0.05)',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'var(--primary-color)', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="bi bi-clock-history"></i> Ventas de Café ({selectedDate})
                        </h2>
                        <button
                            onClick={loadData}
                            style={{
                                background: 'transparent',
                                border: '1px solid var(--border-color)',
                                padding: '0.35rem 0.75rem',
                                borderRadius: '8px',
                                fontSize: '0.8rem',
                                cursor: 'pointer',
                                color: 'var(--primary-color)',
                                fontWeight: '600'
                            }}
                        >
                            <i className="bi bi-arrow-clockwise"></i> Actualizar
                        </button>
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-secondary)' }}>
                            Cargando registros...
                        </div>
                    ) : recentOrders.length === 0 ? (
                        <div style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '3rem',
                            textAlign: 'center',
                            color: 'var(--text-secondary)'
                        }}>
                            <span style={{ fontSize: '3rem', marginBottom: '0.5rem' }}><i className="bi bi-cup-hot-fill"></i></span>
                            <div style={{ fontWeight: '600', marginBottom: '0.25rem' }}>No hay ventas de café registradas hoy</div>
                            <div style={{ fontSize: '0.85rem' }}>Usa la calculadora a la izquierda para despachar el primer paquete de café.</div>
                        </div>
                    ) : (
                        <div style={{ overflowY: 'auto', maxHeight: '550px', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                            {recentOrders.map((order) => (
                                <div
                                    key={order.id}
                                    style={{
                                        padding: '1rem 1.25rem',
                                        borderRadius: '12px',
                                        border: '1px solid var(--border-color)',
                                        background: '#FFFFFF',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                                            <span style={{
                                                background: 'var(--secondary-color)',
                                                color: 'var(--primary-color)',
                                                fontWeight: '800',
                                                fontSize: '0.8rem',
                                                padding: '0.15rem 0.5rem',
                                                borderRadius: '6px'
                                            }}>
                                                #{order.order_sequence || order.id}
                                            </span>
                                            <span style={{ fontWeight: '700', fontSize: '0.95rem', color: 'var(--text-color)' }}>
                                                {order.customer_name || 'CONSUMIDOR FINAL'}
                                            </span>
                                        </div>

                                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', display: 'flex', gap: '0.75rem' }}>
                                            <span><i className="bi bi-scale"></i> {order.coffee_grams || 500}g</span>
                                            <span>•</span>
                                            <span style={{ textTransform: 'capitalize' }}>
                                                {getGrindLabel(order.grind_type || 'grano')}
                                            </span>
                                            <span>•</span>
                                            <span><i className="bi bi-credit-card"></i> {order.payment_method}</span>
                                        </div>
                                    </div>

                                    <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <div>
                                            <div style={{ fontSize: '1.15rem', fontWeight: '800', color: 'var(--primary-color)' }}>
                                                ${parseFloat(order.total || order.total_amount || 0).toFixed(2)}
                                            </div>
                                            <div style={{ fontSize: '0.75rem', color: '#16a34a', fontWeight: '600' }}>
                                                Pagado
                                            </div>
                                        </div>

                                        <button
                                            onClick={() => handlePrintTicket(order)}
                                            title="Reimprimir Comprobante"
                                            style={{
                                                background: '#FAF6F2',
                                                border: '1px solid #E6D7CD',
                                                color: 'var(--primary-color)',
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '1rem'
                                            }}
                                        >
                                            <i className="bi bi-printer-fill"></i>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de Ticket Preview / Éxito */}
            {previewOrder && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1rem'
                }}>
                    <div style={{
                        background: '#FFFFFF',
                        borderRadius: '16px',
                        width: '100%',
                        maxWidth: '420px',
                        padding: '1.75rem',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            background: '#dcfce7',
                            color: '#15803d',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.8rem',
                            margin: '0 auto 1rem'
                        }}>
                            <i className="bi bi-check-lg"></i>
                        </div>

                        <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', color: 'var(--primary-color)', margin: '0 0 0.5rem' }}>
                            ¡Venta de Café Registrada!
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', margin: '0 0 1.25rem' }}>
                            Orden #{previewOrder.order_sequence || previewOrder.id} despachada exitosamente.
                        </p>

                        {/* Detalle Ticket */}
                        <div style={{
                            background: '#FAF6F2',
                            padding: '1.25rem',
                            borderRadius: '12px',
                            border: '1px dashed #D6C2B4',
                            textAlign: 'left',
                            fontSize: '0.85rem',
                            marginBottom: '1.5rem',
                            lineHeight: '1.6'
                        }}>
                            <div style={{ textAlign: 'center', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '0.5rem' }}>
                                {voucherConfig.business_name || "SOPHIA'S COFFEE"}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: 'var(--text-secondary)' }}>Cliente:</span>
                                <span style={{ fontWeight: '600' }}>{previewOrder.customer_name || 'CONSUMIDOR FINAL'}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: 'var(--text-secondary)' }}>Peso Total:</span>
                                <span style={{ fontWeight: '700' }}>{previewOrder.total_grams || (weightGrams * packageCount)} gramos</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: 'var(--text-secondary)' }}>Molienda:</span>
                                <span style={{ fontWeight: '600' }}>{previewOrder.grind_label || getGrindLabel(grindType)}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: 'var(--text-secondary)' }}>Precio por gramo:</span>
                                <span>${PRICE_PER_GRAM} USD</span>
                            </div>
                            <hr style={{ border: 'none', borderTop: '1px dashed #D6C2B4', margin: '0.6rem 0' }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.1rem', fontWeight: '800', color: 'var(--primary-color)' }}>
                                <span>TOTAL PAGADO:</span>
                                <span>${parseFloat(previewOrder.total_amount || totalPrice).toFixed(2)}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <button
                                onClick={() => handlePrintTicket(previewOrder)}
                                style={{
                                    flex: 1,
                                    padding: '0.75rem',
                                    background: 'var(--primary-color)',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontWeight: '700',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem'
                                }}
                            >
                                <i className="bi bi-printer-fill"></i> Imprimir Ticket
                            </button>
                            <button
                                onClick={() => setPreviewOrder(null)}
                                style={{
                                    padding: '0.75rem 1.25rem',
                                    background: '#e2e8f0',
                                    color: '#334155',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontWeight: '600',
                                    cursor: 'pointer'
                                }}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Nuevo Cliente */}
            {showCustomerModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000, padding: '1rem' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '14px', width: '100%', maxWidth: '460px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
                        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '2px solid #e5e7eb', background: 'var(--sidebar-bg)', borderRadius: '14px 14px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: '700', color: 'var(--primary-color)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="bi bi-person-plus-fill"></i> Nuevo Cliente
                            </h3>
                            <button onClick={() => setShowCustomerModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: '#64748b' }}>×</button>
                        </div>
                        <form onSubmit={handleCreateCustomer} style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            <div>
                                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>Cédula / RUC</label>
                                <input type="text" value={newCustomer.cedula} onChange={e => setNewCustomer(p => ({ ...p, cedula: e.target.value }))} placeholder="Ej: 0401234567"
                                    style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1.5px solid #d1d5db', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>Correo Electrónico *</label>
                                <input type="email" required value={newCustomer.email} onChange={e => setNewCustomer(p => ({ ...p, email: e.target.value }))} placeholder="correo@ejemplo.com"
                                    style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1.5px solid #d1d5db', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>Nombre *</label>
                                    <input type="text" required value={newCustomer.first_name} onChange={e => setNewCustomer(p => ({ ...p, first_name: e.target.value }))} placeholder="Nombre"
                                        style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1.5px solid #d1d5db', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>Apellido *</label>
                                    <input type="text" required value={newCustomer.last_name} onChange={e => setNewCustomer(p => ({ ...p, last_name: e.target.value }))} placeholder="Apellido"
                                        style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1.5px solid #d1d5db', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }} />
                                </div>
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '4px', color: '#374151' }}>Teléfono</label>
                                <input type="text" value={newCustomer.phone} onChange={e => setNewCustomer(p => ({ ...p, phone: e.target.value }))} placeholder="0987654321"
                                    style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1.5px solid #d1d5db', borderRadius: '8px', fontSize: '0.9rem', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '0.5rem', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={() => setShowCustomerModal(false)}
                                    style={{ flex: 1, padding: '0.75rem', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}>
                                    Cancelar
                                </button>
                                <button type="submit"
                                    style={{ flex: 2, padding: '0.75rem', background: 'var(--primary-color)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 4px 12px rgba(74,31,12,0.2)' }}>
                                    <i className="bi bi-person-check-fill"></i> Crear Cliente
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CafeGrano;
